var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5289 2.29297C19.5289 2.29297 21.9289 4.69297 21.9289 7.69297C21.9289 10.693 19.5289 13.093 16.5289 13.093C13.5289 13.093 11.1289 10.693 11.1289 7.69297C11.1289 4.69297 13.5289 2.29297 16.5289 2.29297ZM16.5289 12.093C18.9289 12.093 20.8289 10.193 20.8289 7.79297C20.8289 5.39297 18.9289 3.49297 16.5289 3.49297C14.1289 3.49297 12.2289 5.39297 12.2289 7.79297C12.2289 10.193 14.1289 12.093 16.5289 12.093Z",
    fill: "#787E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4756 13.7462L19.4756 11.7462L20.1827 11.0391L22.1827 13.0391L21.4756 13.7462Z",
    fill: "#787E82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2129 2C12.3854 2.51002 11.6765 3.19344 11.1367 4H4V19C4 19.5523 4.44772 20 5 20H16V14.4531C16.2457 14.4802 16.4952 14.4961 16.748 14.4961C17.176 14.4961 17.5941 14.4531 18 14.377V15H22V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H13.2129ZM18 19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V17H18V19ZM11 17H6V15H11V17ZM10.835 11C11.2603 11.7717 11.8326 12.4502 12.5137 13H6V11H10.835ZM10.043 7C10.0159 7.24567 10 7.49516 10 7.74805C10 8.17591 10.041 8.59424 10.1172 9H6V7H10.043Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceAll);
export default __webpack_public_path__ + "static/media/invoice-all.4810f7c096620da886a42fbbb1d38a6f.svg";
export { ForwardRef as ReactComponent };